// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal--turbo .Polaris-Modal-Dialog__Modal {
    width: 788px;
    border-radius: 12px;
}

.modal-boost-turbo {
    position: relative;
    width: 788px;
    height: 340px;
    overflow: hidden;
}

.modal-boost-turbo map {
    position: absolute;
    top: 0;
    left: 0;
}

.modal-boost-turbo img {
    max-height: 100%;
    max-width: 100%;
}

.modal-boost-turbo .closeBtn {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 999;
}

.modal-boost-turbo .btn-blind {
    width: 257px;
    height: 41px;
    position: absolute;
    cursor: pointer;
    bottom: 62px;
    left: 45px;
}

.modal-boost-turbo .closeBtn:hover .Polaris-Icon__Svg {
    fill: white;
}


.modal-boost-turbo .closeBtn .Polaris-Icon__Svg {
    fill: white;
}

.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Dialog__Modal {
    width: 850px;
    max-width: 850px !important;
    border-radius: 8px;
}

.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Header {
    border: 0;
}

.custom-modal.custom-modal--turbo-how-to-claim .Polaris-Modal-Header {
    border: 1px solid var(--p-divider);
}

.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Footer {
    justify-content: flex-end;
}

.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Footer .Polaris-ButtonGroup__Item {
    margin-left: 1rem;
}

/* Discount input row: full-width, input + Apply button inline */
.cost-breakdown-modal .discountCode {
  display: flex;
  align-items: flex-start;
  width: 100%;
}

.cost-breakdown-modal .discountCode .Polaris-Connected__Item--primary {
  margin-right: 4px;
}

.cost-breakdown-modal .discountCode .Polaris-TextField {
  min-width: 220px;
}

.cost-breakdown-modal .discountCode .Polaris-TextField__ClearButton {
  margin: 5px 8px;
}

.cost-breakdown-modal .discountCode .Polaris-TextField__ConnectedRight .Polaris-Button {
  background: #008060;
  color: #ffffff;
  border-color: #008060;
  border-radius: 0 4px 4px 0;
  height: 100%;
}

.cost-breakdown-modal .discountCode .Polaris-TextField__ConnectedRight .Polaris-Button:hover {
  background: #006e52;
  border-color: #006e52;
}

.cost-breakdown-modal .discountCode .Polaris-TextField__ConnectedRight .Polaris-Button--disabled {
  background: var(--p-action-primary-disabled);
  border-color: transparent;
  color: var(--p-text-disabled);
}

/* Discount input section wrapper (shown when input is open) */
.cost-breakdown-modal .discount-input-wrapper {
  margin-top: 6px;
}

/* Default discount row: link/badge on left, price on right */
.cost-breakdown-modal .discount-default-row {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
}

/* Discount link / Apply new discount column */
.cost-breakdown-modal .discount-link-col {
  display: flex;
  flex-direction: column;
}

/* Applied code badge shown without clear button (pricing update default state) */
.cost-breakdown-modal .discount-link-col .code {
  margin-bottom: 4px;
  width: fit-content;
}

/* "Add a discount code" / "Apply new discount" link */
.cost-breakdown-modal .discount-add-link {
  color: #2c6ecb;
  cursor: pointer;
}

/* Discounted amount (green price on the right) */
.cost-breakdown-modal .discount-amount {
  color: #008060;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modal.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,8DAA8D;AAC9D;EACE,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,cAAc;AAChB","sourcesContent":[".custom-modal--turbo .Polaris-Modal-Dialog__Modal {\n    width: 788px;\n    border-radius: 12px;\n}\n\n.modal-boost-turbo {\n    position: relative;\n    width: 788px;\n    height: 340px;\n    overflow: hidden;\n}\n\n.modal-boost-turbo map {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.modal-boost-turbo img {\n    max-height: 100%;\n    max-width: 100%;\n}\n\n.modal-boost-turbo .closeBtn {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    z-index: 999;\n}\n\n.modal-boost-turbo .btn-blind {\n    width: 257px;\n    height: 41px;\n    position: absolute;\n    cursor: pointer;\n    bottom: 62px;\n    left: 45px;\n}\n\n.modal-boost-turbo .closeBtn:hover .Polaris-Icon__Svg {\n    fill: white;\n}\n\n\n.modal-boost-turbo .closeBtn .Polaris-Icon__Svg {\n    fill: white;\n}\n\n.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Dialog__Modal {\n    width: 850px;\n    max-width: 850px !important;\n    border-radius: 8px;\n}\n\n.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Header {\n    border: 0;\n}\n\n.custom-modal.custom-modal--turbo-how-to-claim .Polaris-Modal-Header {\n    border: 1px solid var(--p-divider);\n}\n\n.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Footer {\n    justify-content: flex-end;\n}\n\n.custom-modal.custom-modal--turbo-campaign .Polaris-Modal-Footer .Polaris-ButtonGroup__Item {\n    margin-left: 1rem;\n}\n\n/* Discount input row: full-width, input + Apply button inline */\n.cost-breakdown-modal .discountCode {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.cost-breakdown-modal .discountCode .Polaris-Connected__Item--primary {\n  margin-right: 4px;\n}\n\n.cost-breakdown-modal .discountCode .Polaris-TextField {\n  min-width: 220px;\n}\n\n.cost-breakdown-modal .discountCode .Polaris-TextField__ClearButton {\n  margin: 5px 8px;\n}\n\n.cost-breakdown-modal .discountCode .Polaris-TextField__ConnectedRight .Polaris-Button {\n  background: #008060;\n  color: #ffffff;\n  border-color: #008060;\n  border-radius: 0 4px 4px 0;\n  height: 100%;\n}\n\n.cost-breakdown-modal .discountCode .Polaris-TextField__ConnectedRight .Polaris-Button:hover {\n  background: #006e52;\n  border-color: #006e52;\n}\n\n.cost-breakdown-modal .discountCode .Polaris-TextField__ConnectedRight .Polaris-Button--disabled {\n  background: var(--p-action-primary-disabled);\n  border-color: transparent;\n  color: var(--p-text-disabled);\n}\n\n/* Discount input section wrapper (shown when input is open) */\n.cost-breakdown-modal .discount-input-wrapper {\n  margin-top: 6px;\n}\n\n/* Default discount row: link/badge on left, price on right */\n.cost-breakdown-modal .discount-default-row {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 6px;\n}\n\n/* Discount link / Apply new discount column */\n.cost-breakdown-modal .discount-link-col {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Applied code badge shown without clear button (pricing update default state) */\n.cost-breakdown-modal .discount-link-col .code {\n  margin-bottom: 4px;\n  width: fit-content;\n}\n\n/* \"Add a discount code\" / \"Apply new discount\" link */\n.cost-breakdown-modal .discount-add-link {\n  color: #2c6ecb;\n  cursor: pointer;\n}\n\n/* Discounted amount (green price on the right) */\n.cost-breakdown-modal .discount-amount {\n  color: #008060;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
